import BaseAPIService from './BaseAPIService';
import { setAuth } from './AuthService';

export default class loginSocialService extends BaseAPIService {
	constructor() {
		super();
	}

	getGoogleAuth() {
		return new Promise((resolve, reject) => {
			const loadSuccessCallback = function() {
				const auth2 = gapi.auth2.init({
					client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
				});
				resolve(auth2);
			};

			gapi.load('auth2', loadSuccessCallback, reject);
		});
	}

	getFacebookAccessToken() {
		return new Promise((resolve, reject) => {
			FB.login(function(response) {
				if (response.authResponse) {
					resolve(response.authResponse.accessToken);
				} else {
					reject('User cancelled login or did not fully authorize.');
				}
			});
		});
	}

	async loginGoogle() {
		const auth = await this.getGoogleAuth();
		const signinResult = await auth.signIn();
		const { id_token: idToken } = signinResult.getAuthResponse();
		const mutation = require('@/graphql/mutations/loginWithGoogle.gql');
		const variables = {
			idToken,
		};
		const response = await this.mutate({
			mutation,
			variables,
		});
		const result = response.data.loginWithGoogle;
		setAuth(result);
		return result;
	}

	async loginFacebook() {
		const accessToken = await this.getFacebookAccessToken();
		const mutation = require('@/graphql/mutations/loginWithFacebook.gql');
		const variables = {
			accessToken,
		};
		const response = await this.mutate({
			mutation,
			variables,
		});
		const result = response.data.loginWithFacebook;
		setAuth(result);
		return result;
	}
}
